/**
 * <afo-catalog> — "Our Catalog" band (feature/homepage).
 * Single behavior: the bottom-right arrow scrolls the card strip by one
 * card width. Cards themselves scroll natively (scroll-snap).
 */
if (!customElements.get('afo-catalog')) {
  customElements.define(
    'afo-catalog',
    class AfoCatalog extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }
      #onClick = (e) => {
        if (!e.target.closest('[data-catalog-next]')) return;
        const scroller = this.querySelector('.afo-catalog__cards');
        const card = scroller?.querySelector('.afo-catalog__card');
        if (scroller && card) {
          scroller.scrollBy({ left: card.offsetWidth + 24, behavior: 'smooth' });
        }
      };
    },
  );
}
